"use strict";

require("@polkadot/api/augment/rpc");

require("./augment-api-consts");

require("./augment-api-query");

require("./augment-api-rpc");

require("./augment-api-tx");